import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledDivDefaultImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 240px;
	width: 100%;
`);
export const StyledDivImageContainer = styled('div') `
	position: relative;
	text-align: center;
	padding-bottom: ${Magnetic.spacer64};
	padding-top: ${Magnetic.spacer12};
`;
export const StyledDivButtonContainer = styled('div') `
	position: absolute;
	bottom: ${Magnetic.spacer24};
	width: 100%;
	cursor: ${Magnetic.buttonBaseCursor};
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
	bottom: ${Magnetic.spacer24};
	position: absolute;
	left: calc(50% - 25px);
	cursor: ${Magnetic.buttonBaseCursor};
`;
export const StyledDivImageButton = styled('button') `
	${StyleDivBaseImage}
	background-color: ${(props) => props.backgroundColor};
	color: ${Magnetic.colorWhite};
`;
export const StyledDivImage = styled('img') `
	${StyleDivBaseImage}
`;
//# sourceMappingURL=SingleWideShotComponent.style.js.map